import {DocumentModel, VisibilitySet} from '@/engine';
import {DocumentContextType} from '../document-context';
import {useResetCompleteForm} from './use-reset-complete-form';
import {useResetCurrentSection} from './use-reset-current-section';
import {useResubmitForSignature} from './use-resubmit-for-signature';
import {useSaveChanges} from './use-save-changes';
import {useSetSectionValidity} from './use-set-section-validity';
import {useSubmitForSignature} from './use-submit-for-signature';
import {useSubmitSection} from './use-submit-section';

type UseDocumentActionsProps = {
  formSectionId: string;
  nextSectionId: string | null;
  setCurrentSectionId: DocumentContextType['setCurrentSectionId'];
  markCurrentSectionAsCleared: () => void;
  documentModel: DocumentModel;
  visibilitySet: VisibilitySet;
};

export const useDocumentActions = ({
  formSectionId,
  nextSectionId,
  setCurrentSectionId,
  markCurrentSectionAsCleared,
  documentModel,
  visibilitySet,
}: UseDocumentActionsProps) => {
  const setSectionValidity = useSetSectionValidity();
  const saveChanges = useSaveChanges({visibilitySet});
  const submitForSignature = useSubmitForSignature({visibilitySet});
  const resubmitForSignature = useResubmitForSignature({visibilitySet});
  const resetCurrentSection = useResetCurrentSection({
    formSection: formSectionId,
    documentModel,
    markCurrentSectionAsCleared,
  });
  const resetCompleteForm = useResetCompleteForm({documentModel, setCurrentSectionId});
  const submitSection = useSubmitSection({
    formSectionId,
    nextSectionId,
    documentModel,
    setCurrentSectionId,
    saveChanges,
  });

  return {
    setSectionValidity,
    saveChanges,
    submitSection,
    resetCurrentSection,
    resetCompleteForm,
    submitForSignature,
    resubmitForSignature,
  };
};
